import * as React from "react";

import PhoneInputForm, { PhoneInputFormValues } from "./PhoneInputForm";
import "./PhoneInput.css";

export interface PhoneInputProps {
  phonePrefixOptions: JSX.Element[];
  handlePhoneInputSubmit: (values: PhoneInputFormValues) => void;
}

const PhoneInput = (props: PhoneInputProps) => (
  <div className="phone-input">
    <p className="phone-input__noti">
      Bạn không tìm thấy sản phẩm mình cần? Vui lòng để lại số điện thoại tại
      đây
    </p>
    <PhoneInputForm
      {...props}
      initialValues={{
        source: "WIZARD_PRODUCT_ENQUIRY",
      }}
      onSubmit={props.handlePhoneInputSubmit}
    />
    <p className="phone-input__noti">
      Chúng tôi sẽ gọi điện trực tiếp để tư vấn giúp bạn.
    </p>
  </div>
);

export default PhoneInput;



// WEBPACK FOOTER //
// ./src/routes/Step1/components/PhoneInput.tsx